import apiRequestType from "../../apiRequestType";
import { apiTypes } from "../../../utils/apiTypes";
import { apiConstants } from "../../../utils/apiConstants";

const getShotclassSourcingClassDetailsById = (id, status) => {
  return apiRequestType(
    apiTypes.GET,
    apiConstants.SOCIAL.MODERATE_CONTRIBUTIONS.GET_SHOTCLASS_SOURCING_CLASS_DETAILS_BY_ID(
      id,
      status
    )
  );
};

export default getShotclassSourcingClassDetailsById;
